const US_POSTAL_CODE_REGEX = /^\d{5}$|^\d{5}-\d{4}$/
const CANADA_POSTAL_CODE_REGEX = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] [0-9][A-Z][0-9]$/
const CANADA_FSA_CODE_REGEX = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z]$/

export const isUSPostalCode = input => US_POSTAL_CODE_REGEX.test(input)

export const isCanadaFSA = input => CANADA_FSA_CODE_REGEX.test(input)

export const isCanadaPostalCode = input => CANADA_POSTAL_CODE_REGEX.test(input)

export const isPostalCode = input => isUSPostalCode(input) || isCanadaFSA(input)
